import DateTimeUtils from '@/utils/DateTimeUtils'

export default {
  methods: DateTimeUtils
}
